import { NgModule } from '@angular/core';
import { CxDatePipe } from '@spartacus/core';
import { TodayTomorrowDatePipe } from './today-tomorrow-date.pipe';

@NgModule({
  declarations: [TodayTomorrowDatePipe],
  exports: [TodayTomorrowDatePipe],
  providers: [CxDatePipe, TodayTomorrowDatePipe],
})
export class TodayTomorrowDatePipeModule {}
